/**
 * @generated SignedSource<<9466b9033be0e9fee355d1cbdfb0d93b>>
 * @relayHash 99d43ae8b6cbec26b8714e59e7cba195
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91e548716ea452bdac3a2ddc6cb21ee641df1c6b1d2d9928961233953cc8b613

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "91e548716ea452bdac3a2ddc6cb21ee641df1c6b1d2d9928961233953cc8b613",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
